<template>
    <div class="content">
        <select id="time-select" v-model="timeSelect">
            <option value="按日计">按日计</option>
            <option value="按周计">按周计</option>
            <option value="按月计">按月计</option>
            <option value="按年计">按年计</option>
        </select>
        <div id="project-trends-line" ref="TrendsLine">

        </div>
        <div id="project-trends-bar" ref="TrendsBar"></div>
    </div>
</template>

<script>
    import options from './../../../../utils/options'
    import echarts from 'echarts'

    export default {
        name: "Trendsv2",
        props: ['TimeData', 'selectArea', 'selectTime', 'selectType'],

        data() {
            return {
                charLine: '',
                chartBar: '',
                timeSelect: '按日计',
                optionTrendsLine: options.optionTrendsLine,
                optionTrendsBar: options.optionTrendsBar,
                dataInfo: []
            }
        },

        computed: {
            select() {
                return {'地区选择': this.selectArea, '时间选择': this.selectTime, '行业选择': this.selectType}
            }
        },

        methods: {
            chartInit() {
                this.chartLine = echarts.init(this.$refs.TrendsLine);
                this.chartBar = echarts.init(this.$refs.TrendsBar);
                this.chartLine.showLoading();
                this.chartBar.showLoading()
            },

            chartLoading() {
                this.chartLineLoading(this.dataInfo.xAxis, this.dataInfo.yAxis_all, this.dataInfo.yAxis_shu, this.dataInfo.yAxis_biao);
                this.chartBarLoading()
            },
            chartLineLoading(xAxis, yAxis_all, yAxis_shu, yAxis_biao) {
                this.optionTrendsLine.xAxis.data = xAxis;
                this.optionTrendsLine.series[0].data = yAxis_all;
                this.optionTrendsLine.series[1].data = yAxis_shu;
                this.optionTrendsLine.series[2].data = yAxis_biao;
                this.chartLine.hideLoading();
                this.chartLine.setOption(this.optionTrendsLine, true)
            },
            chartBarLoading() {
                this.optionTrendsBar.angleAxis.data = this.dataInfo.week_xAxis;
                this.optionTrendsBar.series[0].data = this.dataInfo.week_yAxis_biao;
                this.optionTrendsBar.series[1].data = this.dataInfo.week_yAxis_shu;
                this.chartBar.hideLoading();
                this.chartBar.setOption(this.optionTrendsBar, true)
            },

            formatDate(val) {
                let xAxis = [];
                let yAxis_all = [];
                let yAxis_biao = [];
                let yAxis_shu = [];

                let week_xAxis = ["星期天", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
                let week_yAxis_biao = [0, 0, 0, 0, 0, 0, 0];
                let week_yAxis_shu = [0, 0, 0, 0, 0, 0, 0];

                for (let value of val['总数']) {
                    yAxis_all.push(value);
                    xAxis.push(value.name)
                }

                for (let value of val['报告表']) {
                    yAxis_biao.push(value);
                    let date = new Date(Date.parse(value.name)).getDay();
                    week_yAxis_biao[date] += value.value
                }

                for (let value of val['报告书']) {
                    yAxis_shu.push(value);
                    let date = new Date(Date.parse(value.name)).getDay();
                    week_yAxis_shu[date] += value.value
                }

                return {xAxis, yAxis_all, yAxis_biao, yAxis_shu, week_xAxis, week_yAxis_biao, week_yAxis_shu}
            },

            getYearWeek(year, month, date) {
                let dateNow = new Date(year, parseInt(month) - 1, date);
                let dateFirst = new Date(year, 0, 1);
                let dataNumber = Math.round((dateNow.valueOf() - dateFirst.valueOf()) / 86400000);
                return Math.ceil((dataNumber + ((dateFirst.getDay() + 1) - 1)) / 7);
            },

            WeekData() {
                let xAxis = [];
                let yAxis_all = [];
                let yAxis_biao = [];
                let yAxis_shu = [];
                for (let i in this.TimeData['总数']) {
                    let year = this.TimeData['总数'][i].name.split('-')[0];
                    let month = this.TimeData['总数'][i].name.split('-')[1];
                    let day = this.TimeData['总数'][i].name.split('-')[2];
                    let week = this.getYearWeek(year, month, day);
                    let weekStr = year + '年\n第' + week + '周';
                    if (xAxis.indexOf(weekStr) === -1) {
                        xAxis.push(weekStr);
                        yAxis_all.push(this.TimeData['总数'][i].value);
                        yAxis_biao.push(this.TimeData['报告表'][i].value);
                        yAxis_shu.push(this.TimeData['报告书'][i].value)
                    } else {
                        yAxis_all[xAxis.indexOf(weekStr)] += this.TimeData['总数'][i].value;
                        yAxis_biao[xAxis.indexOf(weekStr)] += this.TimeData['报告表'][i].value;
                        yAxis_shu[xAxis.indexOf(weekStr)] += this.TimeData['报告书'][i].value
                    }
                }
                return [xAxis, yAxis_all, yAxis_biao, yAxis_shu]
            },

            MonthData() {
                let xAxis = [];
                let yAxis_all = [];
                let yAxis_biao = [];
                let yAxis_shu = [];

                for (let i in this.TimeData['总数']) {
                    let year = this.TimeData['总数'][i].name.split('-')[0];
                    let month = this.TimeData['总数'][i].name.split('-')[1];
                    let monthStr = year + '年' + month + '月';
                    if (xAxis.indexOf(monthStr) === -1) {
                        xAxis.push(monthStr);
                        yAxis_all.push(this.TimeData['总数'][i].value);
                        yAxis_biao.push(this.TimeData['报告表'][i].value);
                        yAxis_shu.push(this.TimeData['报告书'][i].value)
                    } else {
                        yAxis_all[xAxis.indexOf(monthStr)] += this.TimeData['总数'][i].value;
                        yAxis_biao[xAxis.indexOf(monthStr)] += this.TimeData['报告表'][i].value;
                        yAxis_shu[xAxis.indexOf(monthStr)] += this.TimeData['报告书'][i].value
                    }
                }
                return [xAxis, yAxis_all, yAxis_biao, yAxis_shu]
            },
            YearData() {
                let xAxis = [];
                let yAxis_all = [];
                let yAxis_biao = [];
                let yAxis_shu = [];

                for (let i in this.TimeData['总数']) {
                    let year = this.TimeData['总数'][i].name.split('-')[0];
                    let yearStr = year + '年';
                    if (xAxis.indexOf(yearStr) === -1) {
                        xAxis.push(yearStr);
                        yAxis_all.push(this.TimeData['总数'][i].value);
                        yAxis_biao.push(this.TimeData['报告表'][i].value);
                        yAxis_shu.push(this.TimeData['报告书'][i].value)
                    } else {
                        yAxis_all[xAxis.indexOf(yearStr)] += this.TimeData['总数'][i].value;
                        yAxis_biao[xAxis.indexOf(yearStr)] += this.TimeData['报告表'][i].value;
                        yAxis_shu[xAxis.indexOf(yearStr)] += this.TimeData['报告书'][i].value
                    }
                }
                return [xAxis, yAxis_all, yAxis_biao, yAxis_shu]
            }

        },

        watch: {
            select() {
                this.chartLine.showLoading();
                this.chartBar.showLoading()
            },

            TimeData: {
                handler(val) {
                    this.dataInfo = this.formatDate(val);
                    this.chartLoading()
                },
                deep: true,
            },
            timeSelect(val) {
                let newData = [this.dataInfo.xAxis, this.dataInfo.yAxis_all, this.dataInfo.yAxis_shu, this.dataInfo.yAxis_biao];
                if (val === '按周计') {
                    newData = this.WeekData()
                } else if (val === '按月计') {
                    newData = this.MonthData()
                } else if (val === '按年计') {
                    newData = this.YearData()
                }
                this.chartLineLoading(newData[0], newData[1], newData[2], newData[3])
            }
        },

        mounted() {
            this.chartInit()
        }
    }

</script>

<style scoped>
    .content {
        height: 100vh;
        width: 1640px;
        position: relative;
    }

    #project-trends-line {
        width: 68%;
        height: 90vh;
        float: left;
        /*margin-right: 30px;*/
        /*margin-top: 30px;*/
        padding-top: 120px;
    }

    #project-trends-bar {
        width: 32%;
        height: 90vh;
        float: left;
        /*margin-right: 30px;*/
        /*margin-top: 30px;*/
        padding-top: 120px;
    }

    #time-select {
        position: absolute;
        /*position: relative;*/
        z-index: 999;
        left: 980px;
        top: 200px;
        /*background-color: #f7f7f7;*/
        width: 75px;
    }

</style>